import { useEffect, useState } from "react";

import {
  Container,
  Row,
  Col,
  Form,
  Card,
  Table,
  Button,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import CustomPricingTable from "./customPricingTable";
import { MdRefresh } from "react-icons/md";
import PricingTable from "./pricingTable";
import { motion, AnimatePresence, LayoutGroup } from "framer-motion";
import { FiGlobe, FiHome, FiSettings, FiRefreshCw } from "react-icons/fi";
import styled from "styled-components";
import image from "../../../assets/images/mainLogo.png";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import {
  getCountryList,
  getCityList,
  getStateList,
} from "../../../services/system.js";
import { sendMultiPartMedia } from "../../../services/uplaodMedai";
import {
  onBoardOrganization,
  onBoardRegion,
  onBoardSite,
} from "../../../services/authentication.js";
import {
  getPlanList,
  getSystemServices,
  customUserPlan,
} from "../../../services/planServices";
import {
  callToast,
  showErrorMessages,
} from "../../../services/utilityFunctions";
import "../../../assets/css/onboarding.css";
import { getLocalStorageData } from "../../../services/axiosComponent";
import { DropdownIndicator } from "../../../views/dashboard/widget/tableWidget";
import ToggleSwitch from "../widget/toggleSwtich";
import { planColors, selectStyle, serviceUrls } from "../../../services/constant";
import OrganizationForm from "../../../components/FormComponents/AddOrganizationForm";
// Styled Components
const StepperContainer = styled(motion.div)`
  position: sticky;
  top: 0;
  padding: 10px 0rem;
  background: #01021dff;
  height: 95vh;
  border-radius: 0 1rem 1rem 0;
  margin: 10px 1rem 20px 1rem;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const FormSection = styled(motion.div)`
  padding: 10px 0rem;
  height: 95vh;
  margin: 10px 2rem 20px 0px;
  border-radius: 1rem;
  overflow-y: auto;
  box-shadow: -8px 0 20px rgba(0, 0, 0, 0.21);
`;

const ProgressStep = styled.div`
  position: relative;
  padding-left: 3rem;
  margin-bottom: 2.5rem;
  &:before {
    content: "";
    display: ${(props) => (props.last ? "none" : "block")};
    position: absolute;
    left: 1.1rem;
    top: 2.5rem;
    height: calc(100% - 20px);
    width: 2px;
    background: ${(props) => (props.active ? "#0d6efd" : "#dee2e6")};
    transition: background 0.3s ease;
  }
`;

const StepIndicator = styled.div`
  width: 2.2rem;
  height: 2.2rem;
  border: 2px solid ${(props) => (props.active ? "#0d6efd" : "#dee2e6")};
  border-radius: 50%;
  position: absolute;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => (props.active ? "#0d6efd" : "#adb5bd")};
  transition: all 0.3s ease;
  font-size: 1rem;
`;

const steps = [
  {
    icon: <FiSettings />,
    title: "Organization Setup",
    subtitle: "Tell us about your organization",
  },
  {
    icon: <FiGlobe />,
    title: "Region Setup",
    subtitle: "Configure regional settings",
  },
  {
    icon: <FiHome />,
    title: "Site Setup",
    subtitle: "Add physical locations",
  },
];

const OnBoarding = () => {
  var navigate = useNavigate();
  const [step, setStep] = useState(0);
  const [stackedRegion, setStackedRegion] = useState([]);
  const [stackedSite, setStackedSite] = useState([]);
  const [organizationForm, setOrganizationForm] = useState({
    name: "",
    logo: null,
    discription: "",
  });
  const [countryId, setCountryId] = useState(null);
  const [regionForm, setRegionForm] = useState({
    name: "",

    description: "",
    organizationId: "",
    managerId: "",
  });
  const [siteForm, setSiteForm] = useState({
    // Site Info
    name: "",
    discription: "",
    // Address Info
    addressLine1: "",
    addressLine2: "",
    postalCode: "",
    // Location Info
    country: {
      value: "",
      label: "",
    },
    state: {
      value: "",
      label: "",
    },
    city: {
      value: "",
      label: "",
    },
  });
  const [error, setError] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [organizationId, setOrganizationId] = useState(null);
  const [regionId, setRegionId] = useState(null);
  const [subRegionSetup, setSubRegionSetup] = useState(false);

  const [onFocus, setOnFocus] = useState({});
  const validateOrganization = () => {
    var isValid = true;
    const errors = {};
    if (organizationForm.logo == null) {
      isValid = false;
      errors.logo = "Logo is required";
    }
    if (!organizationForm.name || organizationForm.name == "") {
      isValid = false;
      errors.name = "Name is required";
    }
    if (!organizationForm.discription || organizationForm.discription == "") {
      isValid = false;
      errors.discription = "Discription is required";
    }
    setError(errors);
    return isValid;
  };
  const validateRegion = () => {
    const errors = {};
    var isValid = true;
    if (!regionForm.name || regionForm.name == "") {
      isValid = false;
      errors.name = "Name is required";
    }
    if (!regionForm.description || regionForm.description == "") {
      isValid = false;
      errors.description = "Discription is required";
    }

    setError(errors);
    return isValid;
  };
  const [activeTab, setActiveTab] = useState("Prebuilt");
  const [stepper, setIsStepper] = useState(true);
  const createSite = async (data, isSubSite, resetSiteForm) => {
    data.organizationId = organizationId;
    data.regionId = regionId;
    data.managerId = getLocalStorageData("profileDetails")._ID;
    var res = await onBoardSite(data);
    if (res.status == "success") {
      callToast("success", res.message);
      setSubSite(true);
      console.log("Site created", res);
      resetSiteForm();
      setStackedSite((prev) => [...prev, data]);
    } else {
      showErrorMessages({ data: res, navigate });
    }
  };
  const createOrganization = async () => {
    var res = await onBoardOrganization({
      id: null,
      name: organizationForm.name,

      description: organizationForm.discription,
    });

    if (res.status == "success") {
      var res2 = await sendMultiPartMedia({
        data: { file: organizationForm.logo },
        url: serviceUrls.ADMIN_SERVICE + "/default/organization/logo/" + res.data._ID,
      });
      if (res2.status == "success") {
        console.log("Organization created", res);
        setOrganizationId(res.data._ID);
        callToast("success", res.message);
        setStep((prev) => prev + 1);
        console.log("Logo uploaded", res2);
      } else {
        showErrorMessages({ data: res2, navigate });
      }
    } else {
      showErrorMessages({ data: res, navigate });
    }
  };
  const createRegion = async (addSubRegion = false) => {
    var res = await onBoardRegion({
      id: null,
      name: regionForm.name,
      description: regionForm.description,
      managerId: getLocalStorageData("profileDetails")._ID,
      organizationId: organizationId,
    });

    if (res.status == "success") {
      setStackedRegion((prev) => [...prev, regionForm]);
      callToast("success", res.message);
      console.log("Region created", res);
      if (regionId == null || regionId == undefined) {
        setRegionId(res.data._ID);
      }

      if (regionId) {
        setStep((prev) => prev + 1);
      } else {
        setRegionForm({
          name: "",
          description: "",
        });
        setSubRegionSetup(!subRegionSetup);
      }
    } else {
      showErrorMessages({ data: res, navigate });
    }
  };

  const handleSubmit = async (e, siteData, isSubSite, resetSiteForm) => {
    e.preventDefault();
    if (isSubmitting) return;

    if (step == 1 && subRegionSetup) {
      setStep((prev) => prev + 1);
      return;
    }
    if (step == 2 && isSubSite) {
      setIsStepper(false);
      return;
    }

    setIsSubmitting(true);
    try {
      if (step < steps.length - 1) {
        if (step == 0) {
          if (validateOrganization()) {
            await createOrganization();
          }
        } else if (step == 1) {
          if (validateRegion()) {
            await createRegion();
          }
        } else if (step == 2) {
        }
      } else {
        await createSite(siteData, isSubSite, resetSiteForm);
        console.log("Onboarding completed!", {
          organizationForm,
          regionForm,
          siteForm,
        });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleAddSubRegion = async (e) => {
    // setSubRegionSetup(!subRegionSetup);
    setStackedRegion((prev) => [...prev, regionForm]);
    setRegionForm({
      name: "",
      description: "",
    });
  };

  const [systemServicesLoading, setSystemServicesLoading] = useState(true);
  const [systemServices, setSystemServices] = useState([]);
  const getSystemServicesList = async () => {
    const res = await getSystemServices({
      organizationId,
    });
    if (res.status == "success") {
      setSystemServices(res.data);
      console.log("System Services", res.data);
    } else {
      showErrorMessages({ data: res, navigate });
    }
    setSystemServicesLoading(false);
  };
  const [subSite, setSubSite] = useState(false);
  const [plans, setPlans] = useState([]);
  const [userPlan, setUserPlan] = useState([]);
  const getUserPlan = async () => {
    const res = await customUserPlan({ organizationId });
    if (res.status == "success") {
      console.log("User Plan", res.data);
      setUserPlan(res.data);
    } else {
      showErrorMessages({ data: res, navigate });
    }
  };
  const getPlans = async () => {
    const res = await getPlanList({ organizationId });
    if (res.status == "success") {
      console.log("Plans", res.data);
      setPlans(res.data);
    } else {
      showErrorMessages({ data: res, navigate });
    }
  };

  useEffect(() => {
    if (organizationId) {
      getUserPlan();
      getSystemServicesList();
      getPlans();
    }
    return () => {};
  }, [organizationId]);

  return (
    <Container fluid className="vh-100 p-0 mt-1 ">
      <LayoutGroup>
        <Row className="g-0 h-100">
          {/* Stepper Column – always visible on large screens */}
          {stepper ? (
            <Col
              lg={4}
              xl={3}
              md={3}
              className={
                "d-flex flex-column justify-content-center align-content-center  "
              }
            >
              <StepperContainer
                layout
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.3 }}
              >
                <div className="px-4  ">
                  {/* Company Header */}
                  <header className="mb-1 d-flex align-items-center">
                    <img
                      src={image}
                      alt="Company Logo"
                      style={{
                        width: "200px",
                        height: "200px",
                        marginRight: "0.75rem",
                        objectFit: "cover",
                        padding: "0px",
                        borderRadius: "8px",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                      }}
                    />
                  </header>

                  {steps.map((s, index) => (
                    <ProgressStep
                      key={s.title}
                      active={index <= step}
                      last={index === steps.length - 1}
                    >
                      <StepIndicator active={index === step}>
                        {s.icon}
                      </StepIndicator>
                      <h5 className="mb-1 text-light">{s.title}</h5>
                      <p className="text-muted mb-0">{s.subtitle}</p>

                      {index == 1 && stackedRegion.length > 0 ? (
                        <UserAvatarStack users={stackedRegion} />
                      ) : null}
                      {index == 2 && stackedSite.length > 0 ? (
                        <UserAvatarStack users={stackedSite} />
                      ) : null}
                    </ProgressStep>
                  ))}
                </div>
              </StepperContainer>
            </Col>
          ) : null}

          {/* Form Section */}
          <Col
            lg={stepper ? 8 : 12}
            xl={stepper ? 9 : 12}
            md={stepper ? 9 : 12}
            className={stepper ? "" : "ms-3"}
          >
            <FormSection
              layout
              transition={{ duration: 0.4, ease: "easeInOut" }}
              className="d-flex flex-column justify-content-top"
            >
              <AnimatePresence mode="wait">
                {stepper ? (
                  <motion.div
                    key={step}
                    initial={{ opacity: 0, x: 30 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -30 }}
                    transition={{ duration: 0.6, ease: "easeInOut" }}
                  >
                    <div
                      className={`text-center ${
                        stepper == 0 ? "mb-2" : "mb-5"
                      }`}
                    >
                      <motion.div
                        className="text-primary mb-4"
                        style={{ fontSize: "3rem" }}
                        initial={{ scale: 0.8, opacity: 0 }}
                        animate={{
                          scale: 1,
                          opacity: 1,
                          rotate: [0, 10, 0, -10, 0],
                          y: [0, -5, 0, -5, 0],
                        }}
                        transition={{
                          duration: 5,
                          ease: "easeInOut",
                          repeat: Infinity,
                          repeatType: "loop",
                        }}
                      >
                        {steps[step].icon}
                      </motion.div>
                      <h1 className="display-5 fw-bold mb-3">
                        {(step == 1 && subRegionSetup) || (step == 2 && subSite)
                          ? "Sub -"
                          : null}{" "}
                        {steps[step].title}
                      </h1>
                      <p className="lead text-muted mb-0 pt-0">
                        {steps[step].subtitle}
                      </p>
                    </div>

                    <Form
                      onSubmit={handleSubmit}
                      className="mx-auto mt-0 pt-0"
                      style={{ maxWidth: "600px" }}
                    >
                      {step === 0 && (
                        <OrganizationForm
                          setOnFocus={setOnFocus}
                          organizationForm={organizationForm}
                          setOrganizationForm={setOrganizationForm}
                          error={error}
                        />
                      )}
                      {step === 1 && (
                        <RegionForm
                          subRegionSetup={subRegionSetup}
                          setError={setError}
                          regionForm={regionForm}
                          countryId={countryId}
                          setCountryId={setCountryId}
                          setRegionForm={setRegionForm}
                          error={error}
                        />
                      )}
                      {step === 2 && (
                        <SiteForm
                          subSite={subSite}
                          setSubSite={setSubSite}
                          siteForm={siteForm}
                          setSiteForm={setSiteForm}
                          error={error}
                          handleSubmit={handleSubmit}
                          setStep={setStep}
                          setError={setError}
                          isSubmitting={isSubmitting}
                        />
                      )}
                      <div className="d-flex justify-content-end gap-3  ">
                        {subRegionSetup == true && step == 1 ? (
                          <div className="d-flex justify-content-end gap-3 mt-5">
                            <motion.button
                              type="button"
                              onClick={handleAddSubRegion}
                              className="btn btn-primary px-5 py-3 d-flex align-items-center gap-2"
                              whileHover={{ scale: isSubmitting ? 1 : 1.02 }}
                              whileTap={{ scale: isSubmitting ? 1 : 0.98 }}
                              disabled={isSubmitting}
                            >
                              {isSubmitting ? (
                                <>
                                  <span
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                  />
                                  <span>Processing...</span>
                                </>
                              ) : (
                                "Add Sub Region"
                              )}
                            </motion.button>
                          </div>
                        ) : null}
                        {step !== 2 && (
                          <div className="d-flex justify-content-end gap-3 mt-5">
                            <motion.button
                              type="submit"
                              className="btn btn-primary px-5 py-3 d-flex align-items-center gap-2"
                              whileHover={{ scale: isSubmitting ? 1 : 1.02 }}
                              whileTap={{ scale: isSubmitting ? 1 : 0.98 }}
                              disabled={isSubmitting}
                            >
                              {isSubmitting ? (
                                <>
                                  <span
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                  />
                                  <span>Processing...</span>
                                </>
                              ) : step === steps.length - 1 ? (
                                "Complete Setup"
                              ) : step == 1 && subRegionSetup ? (
                                "Skip"
                              ) : (
                                "Continue"
                              )}
                            </motion.button>
                          </div>
                        )}
                      </div>
                    </Form>
                  </motion.div>
                ) : (
                  <motion.div
                    key="alternate"
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, x: -30 }}
                    transition={{ duration: 0.6, ease: "easeInOut" }}
                    className="alternative-section text-center p-5 pt-0"
                  >
                    {/* <img
                      src={image}
                      alt="Company Logo"
                      style={{
                        width: "100px",
                        height: "60px",
                        marginRight: "0.75rem",
                        objectFit: "cover",
                      }}
                    /> */}
                    <h2 className="fw-bold">Welcome to the Eazilite</h2>
                    <p className="text-muted">
                      Choose the best Plan for your organisation.
                    </p>

                    <ToggleSwitch
                      setActiveTab={setActiveTab}
                      activeTab={activeTab}
                    />
                    <div className="p-3">
                      {activeTab == "Prebuilt" ? (
                        <PricingTable
                          organizationId={organizationId}
                          systemServices={systemServices}
                          plans={plans}
                        />
                      ) : (
                        <CustomPricingTable
                          organizationId={organizationId}
                          systemServices={systemServices}
                          plans={plans}
                          userPlan={userPlan}
                        />
                      )}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </FormSection>
          </Col>
        </Row>
      </LayoutGroup>
    </Container>
  );
};

// Add these styles
const styles = `


.price-bubble {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 5px 15px rgba(0,0,0,0.2);
  position: absolute;
  bottom: -40px;
  z-index: 2;
  transition: transform 0.3s ease;
}

th, td {
  vertical-align: middle !important;
}


  

}
`;

document.head.insertAdjacentHTML("beforeend", `<style>${styles}</style>`);
// Existing OrganizationForm and RegionForm remain unchanged

const RegionForm = ({
  regionForm,
  setRegionForm,
  error,
  countryId,
  setCountryId,
  subRegionSetup,
  setError,
} = {}) => {
  return (
    <>
      {!subRegionSetup ? (
        <LocationComponent
          setRegionForm={setRegionForm}
          setCountryId={setCountryId}
          countryId={countryId}
          error={error}
          regionForm={regionForm}
          setError={setError}
        />
      ) : (
        <div className="mb-4">
          <label className="form-label">Name</label>
          <Form.Control
            size="lg"
            placeholder="Enter Name..."
            className="py-3"
            value={regionForm.name}
            onChange={(e) =>
              setRegionForm({ ...regionForm, name: e.target.value })
            }
          />
          {error?.name && <small className="text-danger">{error?.name}</small>}
        </div>
      )}

      <div className="mb-4">
        <label className="form-label">Discription</label>
        <Form.Control
          size="lg"
          disabled={!subRegionSetup}
          placeholder="Enter Discription..."
          className="py-3"
          value={regionForm.description}
          onChange={(e) =>
            setRegionForm({ ...regionForm, description: e.target.value })
          }
        />
        {error?.description && (
          <small className="text-danger">{error?.description}</small>
        )}
      </div>
    </>
  );
};

// UPDATED SiteForm as a nested stepper form
const SiteForm = ({
  isSubmitting,
  error,
  subSite,
  setSubSite,
  setError,
  handleSubmit,
} = {}) => {
  var navigate = useNavigate();
  const [form, setForm] = useState({
    // Site Info
    name: "",
    discription: "",
    // Address Info
    addressLine1: "",
    addressLine2: "",
    postalCode: "",
    // Location Info
    country: {
      value: "",
      label: "",
    },
    state: {
      value: "",
      label: "",
    },
    city: {
      value: "",
      label: "",
    },
  });
  const [siteStep, setSiteStep] = useState(0);
  const [loadingCityOptions, setLoadingCityOptions] = useState(false);
  const [loadingCountryOptions, setLoadingCountryOptions] = useState(false);
  const [loadingStateOptions, setLoadingStateOptions] = useState(false);
  const [cityOptions, setCityOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [subServiceSubmitting, setSubServiceSubmitting] = useState(false);
  const validateForm = () => {
    var isValid = true;
    var newError = {};
    if (siteStep == 0) {
      if (form.name == "" || form.name == null) {
        newError = { ...newError, name: "Name is required" };
        isValid = false;
      }
      if (form.discription == "" || form.discription == null) {
        newError = { ...newError, discription: "Discription is required" };
        isValid = false;
      }
      setError(newError);
      return isValid;
    }
    if (siteStep == 1) {
      if (form.addressLine1 == "" || form.addressLine1 == null) {
        newError = { ...newError, addressLine1: "Address Line 1 is required" };
        isValid = false;
      }
      if (form.addressLine2 == "" || form.addressLine2 == null) {
        newError = { ...newError, addressLine2: "Address Line 2 is required" };
        isValid = false;
      }
      if (form.postalCode == "" || form.postalCode == null) {
        newError = { ...newError, postalCode: "Postal Code is required" };
        isValid = false;
      }
      setError(newError);
      return isValid;
    }
    if (siteStep == 2) {
      if (form.country.value == "" || form.country.value == null) {
        newError = { ...newError, country: "Country is required" };
        isValid = false;
      }
      if (form.state.value == "" || form.state.value == null) {
        newError = { ...newError, state: "State is required" };
        isValid = false;
      }
      if (form.city.value == "" || form.city.value == null) {
        newError = { ...newError, city: "City is required" };
        isValid = false;
      }
      setError(newError);
      return isValid;
    }
  };
  const getStateListOptions = async (name = null, countryId) => {
    setLoadingStateOptions(true);
    const res = await getStateList({
      query: name,
      countryId: countryId,
    });
    if (res.status == "success") {
      var list = [];
      if (res.data.entityList.length == 0 && name == null) {
        console.log("name", name);
        setError({ ...error, country: "No States found for this Country." });
      }
      res.data.entityList.map((item) => {
        list.push({
          value: item._ID,
          label: item.NAME,
        });
      });
      setStateOptions(list);
    } else {
      showErrorMessages({ data: res, navigate });
    }
    setLoadingStateOptions(false);
  };

  const getCityListOptions = async (name = null, stateId) => {
    setLoadingCityOptions(true);
    const res = await getCityList({
      query: name,
      stateId: stateId,
      countryId: form.country.value,
    });
    if (res.status == "success") {
      var list = [];
      if (res.data.entityList.length == 0 && name == null) {
        setError({
          ...error,
          state: "No Cities found for this State.",
        });
      }
      res.data.entityList.map((item) => {
        list.push({
          value: item._ID,
          label: item.NAME,
        });
      });
      setCityOptions(list);
    } else {
      showErrorMessages({ data: res, navigate });
    }
    setLoadingCityOptions(false);
  };
  const getCountryListOptions = async (name = null) => {
    setLoadingCountryOptions(true);
    const res = await getCountryList({ query: name });
    console.log(res, "res in country list " + name);
    if (res.status == "success") {
      var list = [];
      console.log(res.data);
      res.data.entityList.map((item) => {
        list.push({
          value: item._ID,
          label: item.NAME,
        });
      });
      setCountryOptions(list);
    } else {
      showErrorMessages({ res, navigate });
    }
    setLoadingCountryOptions(false);
  };
  const [input, setInput] = useState({ field: "" });
  useEffect(() => {
    getCountryListOptions();

    return () => {};
  }, []);

  // Define the sub-steps for the SiteForm
  const siteSubSteps = [
    {
      render: () => (
        <>
          <div className="mb-4">
            <label className="form-label">Name</label>
            <Form.Control
              size="lg"
              placeholder="Enter Name..."
              className="py-3"
              value={form.name}
              onChange={(e) => {
                setForm({ ...form, name: e.target.value });
                setError({ ...error, name: "" });
              }}
            />
            {error.name && <small className="text-danger">{error.name}</small>}
          </div>
          <div className="mb-4">
            <label className="form-label">Discription</label>
            <Form.Control
              size="lg"
              placeholder="Enter Discription..."
              className="py-3"
              value={form.discription}
              onChange={(e) => {
                setForm({ ...form, discription: e.target.value });

                setError({ ...error, discription: "" });
              }}
            />
            {error.discription && (
              <small className="text-danger">{error.discription}</small>
            )}
          </div>
        </>
      ),
    },
    {
      render: () => (
        <>
          <div className="mb-4">
            <label className="form-label">Address Line 1</label>
            <Form.Control
              size="lg"
              placeholder="Enter Address Line 1..."
              className="py-3"
              value={form.addressLine1}
              onChange={(e) => {
                setForm({ ...form, addressLine1: e.target.value });
                setError({ ...error, addressLine1: "" });
              }}
            />
            {error.addressLine1 && (
              <small className="text-danger">{error.addressLine1}</small>
            )}
          </div>
          <div className="mb-4">
            <label className="form-label">Address Line 2</label>
            <Form.Control
              size="lg"
              placeholder="Enter Address Line 2..."
              className="py-3"
              value={form.addressLine2}
              onChange={(e) => {
                setForm({ ...form, addressLine2: e.target.value });
                setError({ ...error, addressLine2: "" });
              }}
            />
            {error.addressLine2 && (
              <small className="text-danger">{error.addressLine2}</small>
            )}
          </div>
          <div className="mb-4">
            <label className="form-label">Postal Code</label>
            <Form.Control
              size="lg"
              placeholder="Enter Postal Code..."
              className="py-3"
              value={form.postalCode}
              onChange={(e) => {
                setForm({ ...form, postalCode: e.target.value });
                setError({ ...error, postalCode: "" });
              }}
            />
            {error.postalCode && (
              <small className="text-danger">{error.postalCode}</small>
            )}
          </div>
        </>
      ),
    },
    {
      render: () => (
        <>
          <div className="mb-4">
            <label className="form-label">Country</label>
            <Select
              options={countryOptions}
              loadingMessage={() => "Loading State..."}
              isLoading={loadingCountryOptions}
              value={form.country.label == "" ? null : form.country}
              onChange={(value) => {
                setForm({
                  ...form,
                  country: value,
                  state: { value: "", label: "" },
                  city: { value: "", label: "" },
                });
                setError({ ...error, country: "" });
                getStateListOptions(null, value.value);
              }}
              placeholder="Select Country"
              isSearchable
              onInputChange={(inputValue) => {
                getCountryListOptions(inputValue);
              }}
              styles={selectStyle}
            />
            {error.country && (
              <small className="text-danger">{error.country}</small>
            )}
          </div>
          <div className="mb-4">
            <label className="form-label">State</label>
            <Select
              options={stateOptions}
              loadingMessage={() => "Loading State..."}
              isLoading={loadingStateOptions}
              value={form.state.label == "" ? null : form.state}
              onChange={(value) => {
                setForm({
                  ...form,

                  state: value,
                  city: { value: "", label: "" },
                });

                setError({ ...error, state: "" });
                getCityListOptions(null, value.value);
              }}
              placeholder="Select State"
              isSearchable={form.country.value != ""}
              onInputChange={(inputValue) => {
                getStateListOptions(inputValue, form.country.value);
              }}
              styles={selectStyle}
            />
            {error.state && (
              <small className="text-danger">{error.state}</small>
            )}
          </div>
          <div className="mb-4">
            <label className="form-label">City</label>
            <Select
              options={cityOptions}
              loadingMessage={() => "Loading City..."}
              isLoading={loadingCityOptions}
              value={form.city.label == "" ? null : form.city}
              onChange={(value) => {
                setForm({
                  ...form,

                  city: value,
                });
                setError({ ...error, city: "" });
              }}
              placeholder="Select City"
              isSearchable={form.country.value != "" && form.state.value != ""}
              onInputChange={(inputValue) => {
                getCityListOptions(inputValue, form.state.value);
              }}
              styles={selectStyle}
            />
            {error.city && <small className="text-danger">{error.city}</small>}
          </div>
        </>
      ),
    },
  ];
  const resetSiteForm = () => {
    setForm({
      // Site Info
      name: "",
      discription: "",
      // Address Info
      addressLine1: "",
      addressLine2: "",
      postalCode: "",
      // Location Info
      country: {
        value: "",
        label: "",
      },
      state: {
        value: "",
        label: "",
      },
      city: {
        value: "",
        label: "",
      },
    });
  };
  const handleSiteNext = async (e) => {
    if (subSite) {
      handleSubmit(e, {}, subSite, resetSiteForm);
    }
    e.preventDefault();
    if (siteStep < siteSubSteps.length - 1) {
      if (validateForm()) {
        setSiteStep((prev) => prev + 1);
      }
    } else {
      if (validateForm()) {
        await handleSubmit(
          e,
          {
            id: null,
            name: form.name,
            description: form.discription,

            siteLocation: {
              addressLine1: form.addressLine1,
              addressLine2: form.addressLine2,
              postalCode: form.postalCode,
              cityId: form.city.value,
              stateId: form.state.value,
              countryId: form.country.value,
            },
          },
          subSite,
          resetSiteForm
        );
        setSiteStep(0);
      }

      // On the last sub-step, you might want to perform validation or simply complete the SiteForm.
      // For this example, no extra action is taken here.
    }
  };

  const handleSubSiteNext = async (e) => {
    e.preventDefault();
    if (siteStep < siteSubSteps.length - 1) {
      if (validateForm()) {
        setSiteStep((prev) => prev + 1);
      }
    } else {
      if (validateForm()) {
        await handleSubmit(
          e,
          {
            id: null,
            name: form.name,
            description: form.discription,

            siteLocation: {
              addressLine1: form.addressLine1,
              addressLine2: form.addressLine2,
              postalCode: form.postalCode,
              cityId: form.city.value,
              stateId: form.state.value,
              countryId: form.country.value,
            },
          },
          false,
          resetSiteForm
        );
        setSiteStep(0);
      }

      // On the last sub-step, you might want to perform validation or simply complete the SiteForm.
      // For this example, no extra action is taken here.
    }
  };

  const handleSiteBack = (e) => {
    if (siteStep === 0) {
    }
    e.preventDefault();
    if (siteStep > 0) {
      setSiteStep((prev) => prev - 1);
    }
  };

  return (
    <>
      <AnimatePresence mode="wait">
        <motion.div
          key={siteStep}
          initial={{ opacity: 0, x: 30 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -30 }}
          transition={{ duration: 0.3 }}
        >
          {siteSubSteps[siteStep]?.render()}
          <div className="d-flex justify-content-between gap-3 mt-5">
            <motion.button
              type="button"
              onClick={handleSiteBack}
              className="btn btn-outline-secondary px-5 py-3"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              Back
            </motion.button>
            <div>
              {subSite && (
                <motion.button
                  type="button"
                  onClick={handleSubSiteNext}
                  disabled={isSubmitting}
                  className="btn btn-primary px-5 py-3 me-2"
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  {isSubmitting ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-1 ms-1"
                        role="status"
                        aria-hidden="true"
                      />
                      <span>Processing...</span>
                    </>
                  ) : (
                    "next"
                  )}
                </motion.button>
              )}
              <motion.button
                type="button"
                onClick={handleSiteNext}
                disabled={isSubmitting}
                className="btn btn-primary px-5 py-3"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                {siteStep === siteSubSteps.length - 1 ? (
                  isSubmitting && !subSite ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm ms-1 me-1"
                        role="status"
                        aria-hidden="true"
                      />
                      <span>Processing...</span>
                    </>
                  ) : subSite ? (
                    "Skip"
                  ) : (
                    "Complete Setup"
                  )
                ) : subSite ? (
                  "Skip"
                ) : (
                  "Next"
                )}
              </motion.button>
            </div>
          </div>
        </motion.div>
      </AnimatePresence>
    </>
  );
};

const LocationComponent = ({
  countryId,
  setCountryId,
  setRegionForm,
  regionForm,
  error,
  setError,
} = {}) => {
  const [location, setLocation] = useState(null);

  const [isFetching, setIsFetching] = useState(false);

  const fetchLocation = () => {
    setError((prev) => ({ ...prev, country: "", description: "" }));
    setLocation(null);
    setCountryId("");
    setIsFetching(true);

    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          setLocation({ latitude, longitude });
          setIsFetching(false);

          try {
            const response = await fetch(
              `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`
            );
            const data = await response.json();
            const countryName = data.address?.country || "N/A";
            const countryCode = data.address?.country_code
              ? data.address.country_code.toUpperCase()
              : "N/A";
            setCountryId(`${countryName} (${countryCode})`);
            setRegionForm((prev) => ({
              ...prev,
              name: `${countryCode}`,
              description: `${countryName}`,
            }));
          } catch (err) {
            console.error(err);
            setError("Failed to fetch address.");
            setIsFetching(false);
          }
        },
        (error) => {
          let message;
          switch (error.code) {
            case 1:
              message =
                "Location access denied. Please enable location permissions.";
              break;
            case 2:
              message = "Location unavailable. Try again later.";
              break;
            case 3:
              message = "Location request timed out. Please try again.";
              break;
            default:
              message = "An unknown error occurred.";
          }
          setError((prev) => ({
            ...prev,
            country: message,
            code: error.code,

            description: message,
          }));

          setIsFetching(false);
        }
      );
    } else {
      setError({
        message: "Geolocation is not supported by this browser.",
        code: 0,
      });
      setIsFetching(false);
    }
  };

  useEffect(() => {
    fetchLocation();
  }, []);

  return (
    <div className="mb-4">
      <label className="form-label">Name</label>
      <div className="position-relative">
        <Form.Control
          size="lg"
          placeholder="Detecting location..."
          className="py-3 pe-5" // Added right padding for the icon
          value={regionForm.name}
          readOnly
        />
        <button
          onClick={fetchLocation}
          disabled={isFetching}
          className="position-absolute top-50 end-0 translate-middle-y bg-transparent border-0"
          style={{
            cursor: "pointer",
            transition: "transform 0.2s ease-in-out",
            zIndex: 2,
          }}
          aria-label={isFetching ? "Fetching location" : "Refresh location"}
        >
          {isFetching ? (
            <div
              className="spinner-border spinner-border-sm text-primary"
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
          ) : (
            <MdRefresh
              size={24}
              className="text-primary"
              style={{ transition: "transform 0.2s ease-in-out" }}
            />
          )}
        </button>
      </div>
      {error?.country && (
        <small className="text-danger">{error?.country}</small>
      )}
      {error?.name && <small className="text-danger">{error?.name}</small>}
    </div>
  );
};

// Styled components for the avatar stack
const StackContainer = styled.div`
  display: flex;
  justify-content: start;
  padding: 0.3rem 0rem;
  gap: 0;
  autoscroll: auto;
  width: 17vw;

  overflow: visible;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const Avatar = styled.div`
  width: ${(props) => (props.$isHovered ? "6rem" : "3rem")};
  height: ${(props) => (props.$isHovered ? "6rem" : "3rem")};
  background: ${(props) =>
    props.$isHovered
      ? "var(--bs-primary)"
      : "color-mix(in srgb, var(--bs-primary) 80%, black 20%)"};
  border-radius: ${(props) => (props.$isHovered ? "1rem" : "50%")};
  border: 1px solid white;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-left: -0.75rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  position: relative;
  z-index: ${(props) => (props.$isHovered ? 2 : 1)};
  box-shadow: ${(props) =>
    props.$isHovered ? "0 4px 6px -1px rgba(0, 0, 0, 0.1)" : "none"};

  &:hover {
    transform: ${(props) =>
      props.$isHovered ? "translateY(-0.5rem)" : "none"};
  }

  @media (max-width: 768px) {
    width: ${(props) => (props.$isHovered ? "4.5rem" : "2.25rem")};
    height: ${(props) => (props.$isHovered ? "4.5rem" : "2.25rem")};
    margin-left: -0.5rem;
  }
`;

const Initials = styled.div`
  font-weight: bold;
  transition: font-size 0.3s ease;

  ${Avatar}:hover & {
    font-size: 1.5rem;
    margin-bottom: 0.25rem;
  }

  @media (max-width: 768px) {
    font-size: 0.75rem;

    ${Avatar}:hover & {
      font-size: 1rem;
    }
  }
`;

const Details = styled.div`
  opacity: 0;
  max-height: 0;
  overflow: hidden;
  transition: all 0.3s ease;
  text-align: center;
  font-size: 0.75rem;

  ${Avatar}:hover & {
    opacity: 1;
    max-height: 3rem;
  }

  @media (max-width: 768px) {
    font-size: 0.6rem;
  }
`;

// UserAvatar component
const UserAvatar = ({ user }) => {
  const [isHovered, setIsHovered] = useState(false);

  const getInitials = () => {
    var name = user.name.split(" ");
    if (name.length == 1) {
      if (name[0].length == 1) {
        return name[0].charAt(0).toUpperCase();
      }
      return name[0].charAt(0).toUpperCase() + name[0].charAt(1).toUpperCase();
    } else {
      return name[0].charAt(0).toUpperCase() + name[1].charAt(0).toUpperCase();
    }
  };

  const initials = user.name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase();

  return (
    <Avatar
      $isHovered={isHovered}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Initials>{getInitials()}</Initials>
      <Details>
        <div>{user.description}</div>
      </Details>
    </Avatar>
  );
};

// Main component
const UserAvatarStack = ({ users }) => {
  return (
    <StackContainer>
      {users.map((user, index) => (
        <UserAvatar key={index} user={user} />
      ))}
    </StackContainer>
  );
};

export default OnBoarding;
